module.exports = __webpack_public_path__ + "media/images/slider_img_03-8ff3a13aa8bcf7830fa0849f7b74887b.png";